import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";
import { IHintState } from "@/types/hints/hintsTypes";
import { parseTranslationsFromExcel } from "@/helpers";

interface IinitialState {
	enabled: boolean;
}

const stored = localStorage.getItem("hintModeEnabled");

const initialState: IinitialState & IHintState = {
	enabled: stored ? JSON.parse(stored) : false,
	see: {},
	ses: {},
	sbs: {},
	smc: {},
	cls: {},
	spr: {},
	tts: {},
	qas: {},
};

export const loadServiceHints = createAsyncThunk<{ service: keyof IHintState; hints: Record<string, string> }, { service: keyof IHintState; fileUrl: string }>(
	"hints/loadServiceHints",
	async ({ service, fileUrl }) => {
		const response = await fetch(fileUrl);
		const blob = await response.blob();
		const file = new File([blob], "hints.xlsx");
		const hints = await parseTranslationsFromExcel(file);
		return { service, hints };
	}
);

export const hintsSlice = createSlice({
	name: "hints",
	initialState,
	reducers: {
		setHintsEnabled: (state, action: PayloadAction<boolean>) => {
			state.enabled = action.payload;
		},
		toggleHints: (state) => {
			state.enabled = !state.enabled;
		},
		setServiceHints: (state, action: PayloadAction<{ service: keyof IHintState; hints: Record<string, string> }>) => {
			const { service, hints } = action.payload;
			state[service] = hints;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(loadServiceHints.fulfilled, (state, action) => {
			const { service, hints } = action.payload;
			state[service] = hints;
		});
	},
});

export const { setHintsEnabled, toggleHints } = hintsSlice.actions;
export const selectHintsEnabled = (state: RootState) => state.hints.enabled;

// Селекторы для конкретного сервиса
export const selectSeeHints = (state: { hints: IHintState }) => state.hints.see;
export const selectSesHints = (state: { hints: IHintState }) => state.hints.ses;
export const selectSbsHints = (state: { hints: IHintState }) => state.hints.sbs;
export const selectSmcHints = (state: { hints: IHintState }) => state.hints.smc;
export const selectClsHints = (state: { hints: IHintState }) => state.hints.cls;
export const selectSprHints = (state: { hints: IHintState }) => state.hints.spr;
export const selectTtsHints = (state: { hints: IHintState }) => state.hints.tts;
export const selectQasHints = (state: { hints: IHintState }) => state.hints.qas;

export default hintsSlice.reducer;
